import { withInstall } from '@tw-element/utils'

import Rate from './src/rate.vue'

export const TwRate = withInstall(Rate)
export default TwRate

export * from './src/rate'
